// extracted by mini-css-extract-plugin
module.exports = {"desktopContainer":"LicenseFree_desktopContainer__wxfBl"};